
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/landing/[id]",
      function () {
        return require("private-next-pages/default/desktop/landing/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/landing/[id]"])
      });
    }
  